import Button from '@nebula/button';
import { TitleLarge500, TitleSmall500 } from '@nebula/global-styles';
import styled from 'styled-components';

export const PaymentInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3.75rem;
  margin-bottom: 2rem;
`;

export const ApplePayOption = styled.div`
  ${({ disabled }) => disabled && 'pointer-events: none;'};

  --apple-pay-button-width: 100%;
  --apple-pay-button-height: 3rem;
  --apple-pay-button-padding: 0.5rem 1rem;
  --apple-pay-button-border-radius: 0.375rem;
  --apple-pay-button-box-sizing: border-box;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: ${({ $needFullWidth }) => ($needFullWidth ? '100%' : '50%')};
  }
`;

export const GooglePayOption = styled.div`
  ${({ disabled }) => disabled && 'pointer-events: none;'};
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: ${({ $needFullWidth }) => ($needFullWidth ? '100%' : '50%')};
  }
`;

export const PaymentChangeButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    gap: 1.5rem;
  }
`;

export const MethodUpdateButton = styled(Button)`
  font-size: 0.875rem;
  width: 100%;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    font-size: 1rem;
    width: 11.375rem;
  }
`;

export const LargePaymentChangeTitle = styled(TitleLarge500)`
  margin: 0 0 1.5rem;
`;

export const StandardPaymentChangeTitle = styled(TitleSmall500)`
  margin: 0 0 0.5rem;
`;

export const Alert = styled.div`
  margin: 0 0 0.5rem;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    margin: 0 0 1.5rem;
  }

  p {
    margin: 0;
  }
`;
